var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOttoMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 332,
    viewBox: "0 0 206 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.039,
    cy: 314.289,
    rx: 78.6936,
    ry: 17.6274,
    fill: "url(#paint0_radial_902_40)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.758 36.0512C132.421 45.1241 139.233 44.3411 149.501 58.8557C160.368 74.2154 165.112 71.7754 170.075 76.4098C175.038 81.0443 179.44 52.8462 159.529 36.6914C146.747 26.3207 129.094 26.9782 130.758 36.0512Z",
    fill: "#AEA075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.988 24.066C136.789 33.734 149.441 37.9898 159.71 52.5045C170.576 67.8642 164.947 81.093 169.91 85.7274C174.873 90.3619 185.774 47.6062 168.098 29.0324C147.606 7.50078 141.186 14.3981 138.988 24.066Z",
    fill: "#D1C394"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7196 37.8829C83.0565 46.9558 76.2442 46.1728 65.9757 60.6875C55.1094 76.0471 50.3652 73.6071 45.402 78.2416C40.4388 82.876 36.0368 54.6779 55.9482 38.5231C68.7305 28.1524 86.3827 28.81 84.7196 37.8829Z",
    fill: "#AEA075"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4887 25.8978C78.6875 35.5657 66.0351 39.8215 55.7666 54.3362C44.9003 69.6959 50.5293 82.9247 45.5661 87.5592C40.6029 92.1936 29.7023 49.438 47.3787 30.8641C67.8699 9.33251 74.2899 16.2298 76.4887 25.8978Z",
    fill: "#D1C294"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1162 244.382C10.6886 224.541 15.0388 197.146 26.8089 191.604C46.0135 227.681 61.5692 283.31 108.924 288.243C69.4118 303.032 25.5437 264.223 18.1162 244.382Z",
    fill: "#C8BA8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3561 130.461L155.416 130.461C155.416 130.461 175.698 157.551 170.064 188.826C162.793 229.183 149.918 314.289 149.918 314.289H69.471C69.471 314.289 58.2072 245.524 47.3018 188.826C40.433 153.115 56.3561 130.461 56.3561 130.461Z",
    fill: "url(#paint1_linear_902_40)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.539 183.624C169.539 183.624 145.724 205.607 106.336 205.607C69.6972 205.607 47.7137 186.372 47.7137 186.372C47.7137 155.007 65.1173 63.6304 106.336 63.6304C142.976 63.6304 169.539 152.259 169.539 183.624Z",
    fill: "url(#paint2_linear_902_40)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2876 319.691C88.5059 315.367 93.1744 293.377 85.7151 270.576C78.2558 247.774 61.4933 232.795 48.2751 237.12C35.0568 241.444 30.3883 263.433 37.8476 286.235C41.139 296.296 46.2418 304.834 52.0521 310.863C51.1461 311.728 50.3564 312.719 49.7461 313.85C46.4591 319.941 48.3765 321.717 49.7461 321.844L68.6146 320.319C70.8958 320.587 73.1386 320.394 75.2876 319.691Z",
    fill: "url(#paint3_linear_902_40)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.012 319.54C131.794 315.216 127.125 293.226 134.585 270.425C142.044 247.623 158.806 232.644 172.025 236.969C185.243 241.293 189.912 263.283 182.452 286.084C179.161 296.145 174.058 304.684 168.247 310.712C169.153 311.578 169.943 312.568 170.553 313.699C173.84 319.79 171.923 321.566 170.553 321.693L151.685 320.168C149.404 320.436 147.161 320.243 145.012 319.54Z",
    fill: "url(#paint4_linear_902_40)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.693 173.9L135.575 305.625C138.891 317.964 136.796 320.065 135.575 326.846H115.214C114.447 320.065 109.055 317.077 117.484 303.839C118.802 272.637 126.841 242.108 127.884 211.043C124.428 211.659 117.484 214.191 110.886 214.191C104.289 214.191 97.9729 211.651 94.518 211.043L103.922 303.913C108.86 314.463 108.161 318.664 106.57 326.88L83.0189 326.846C82.2272 320.065 80.4238 320.719 85.8622 305.996C84.5888 298.619 83.382 291.602 82.2272 284.888C75.9131 248.177 51.0068 202.241 45.4132 173.9H170.693Z",
    fill: "url(#paint5_linear_902_40)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.89 19.1025C32.2678 20.2273 74.6846 120.945 79.2128 129.803C83.7411 138.66 133.204 138.66 137.779 128.917C142.355 119.174 183.512 17.9777 107.89 19.1025Z",
    fill: "url(#paint6_linear_902_40)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3868 128.155L90.8048 126.792L91.1385 130.077L77.7205 131.44L77.3868 128.155Z",
    fill: "#362121"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5347 134.066C78.6054 144.932 69.0431 152.987 58.1768 152.058C47.3105 151.129 39.2549 141.567 40.1842 130.7C41.1135 119.834 50.6757 111.778 61.5421 112.708C72.4084 113.637 80.4639 123.199 79.5347 134.066Z",
    fill: "#8AB2C9",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3912 149.552C67.8731 150.362 76.2171 143.333 77.028 133.851C77.8389 124.369 70.8096 116.025 61.3277 115.214C51.8457 114.403 43.5017 121.433 42.6908 130.915C41.8799 140.397 48.9092 148.741 58.3912 149.552ZM58.1768 152.058C69.0431 152.987 78.6054 144.932 79.5347 134.066C80.4639 123.199 72.4084 113.637 61.5421 112.708C50.6757 111.778 41.1135 119.834 40.1842 130.7C39.2549 141.567 47.3105 151.129 58.1768 152.058Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7415 128.846C83.5888 127.116 84.8676 125.59 86.5976 125.437L133.065 121.337C134.795 121.184 136.321 122.463 136.474 124.193C136.626 125.923 135.347 127.449 133.617 127.602L87.1504 131.702C85.4204 131.855 83.8941 130.576 83.7415 128.846Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.992 123.641C107.992 123.641 83.7893 135.497 83.6309 114.634C83.5168 99.6023 94.4388 88.9974 108.025 88.8942C121.612 88.7911 132.719 99.2287 132.833 114.261C132.983 134.092 107.992 123.641 107.992 123.641Z",
    fill: "#AFA16E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 99.1544C118.242 103.06 113.662 108.803 108.122 108.859C102.583 108.915 98.1815 103.263 98.1421 99.3568C98.1027 95.4508 102.583 94.3608 108.122 94.3049C113.662 94.249 118.163 95.2484 118.202 99.1544Z",
    fill: "#3D3D3D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.413 76.5521C96.68 80.442 92.6836 76.8081 88.0832 77.1239C83.4827 77.4397 80.0204 81.5856 79.7534 77.6958C79.4863 73.8059 83.1443 72.5095 87.7447 72.1937C92.3451 71.8779 96.1459 72.6622 96.413 76.5521Z",
    fill: "#3D3D3D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.461 76.5521C120.194 80.442 124.19 76.8081 128.791 77.1239C133.391 77.4397 136.853 81.5856 137.12 77.6958C137.387 73.8059 133.729 72.5095 129.129 72.1937C124.529 71.8779 120.728 72.6622 120.461 76.5521Z",
    fill: "#3D3D3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_902_40",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.039 314.289) rotate(90) scale(17.6274 78.6936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_902_40",
    x1: 108.626,
    y1: 64.5464,
    x2: 109.627,
    y2: 312.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#E0D2A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#B5A87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_902_40",
    x1: 108.626,
    y1: 64.5464,
    x2: 109.627,
    y2: 312.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#E0D2A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#B5A87C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_902_40",
    x1: 46.6723,
    y1: 236.226,
    x2: 48.561,
    y2: 321.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6B88A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_902_40",
    x1: 173.627,
    y1: 236.075,
    x2: 171.739,
    y2: 321.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6B88A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_902_40",
    x1: 108.368,
    y1: 174.529,
    x2: 110.257,
    y2: 326.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CB9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BA90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_902_40",
    x1: 108.168,
    y1: 19.0932,
    x2: 108.168,
    y2: 136.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9F6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOttoMagnifyingGlass);
export default __webpack_public_path__ + "static/media/otto-magnifying-glass.af2fa94879d3150a6493f4bd91109ce1.svg";
export { ForwardRef as ReactComponent };